import { defineNuxtPlugin } from '#app'
import posthog from 'posthog-js'
export default defineNuxtPlugin(nuxtApp => {
  const runtimeConfig = useRuntimeConfig()
  const posthogClient = posthog.init(runtimeConfig.public.posthog.publicKey, {
    api_host: runtimeConfig.public.posthog.host,
    person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
    capture_pageview: false, // we add manual pageview capturing below
    loaded: posthog => {
      if (import.meta.env.MODE === 'development') posthog.debug()
    },
    before_send: event => {
      if (!event) {
        return null
      }

      event.properties.fm2_version =
        runtimeConfig.public.datadog.version || 'dev'

      return event
    },
  })

  // Make sure that pageviews are captured with each route change
  const router = useRouter()
  router.afterEach(to => {
    nextTick(() => {
      posthog.capture('$pageview', {
        current_url: to.fullPath,
      })
    })
  })

  return {
    provide: {
      posthog: () => posthogClient,
    },
  }
})
